var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tianmu-player-card"},[(_vm.showLabel)?_c('div',{staticClass:"play-status"},[_vm._v(" "+_vm._s(_vm.PLAY_STATUS[_vm.isPlaying])+" ")]):_vm._e(),_c('div',{staticClass:"play-button",on:{"click":function($event){$event.stopPropagation();return _vm.handleClick.apply(null, arguments)}}},[_c('img',{staticClass:"play-icon",attrs:{"src":_vm.isPlaying === 1
        ? require('@/assets/img/tianmu/scenePause.png')
        : require('@/assets/img/tianmu/scenePlaying.png')}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }